<page-toolbar [pageActions]="pageActions" title="Kue UI"></page-toolbar>

<div>
  <iframe src="https://my.ibexfusion.com/queue/ui/active"></iframe>
</div>
